import React from "react";
import { GridContainer } from "../../SmartTableContainer.styled";

const GridView = ({ data, onItemClick, itemToRender, columns = 3 }) => {
  return (
    <GridContainer columns={columns}>
      {data.map((item) => (
        <div key={item.id} onClick={() => onItemClick?.(item)}>
          {React.cloneElement(itemToRender, { ...item })}
        </div>
      ))}
    </GridContainer>
  );
};

export default GridView; 